import {
  CanopyProvider,
  BaseDialog as DialogBase,
  BaseRequiredDialogProps as DialogBaseRequiredProps,
  DialogHeader,
  DownloadIcon,
} from '@bloomfieldrobotics/canopy';
import { IconButton } from '@mui/material';
import { useGridApiRef } from '@mui/x-data-grid';
import { GridApiCommunity } from '@mui/x-data-grid/internals';
import { MutableRefObject } from 'react';

type Props = DialogBaseRequiredProps & {
  title: string;
  exportFileName: string;
  GridComponent: React.ComponentType<{
    dataGridApiRef: MutableRefObject<GridApiCommunity>;
  }>;
};

export const DataGridDialogWithDownload = ({
  open,
  onClose,
  title,
  GridComponent,
  exportFileName,
}: Props) => {
  const dataGridApiRef = useGridApiRef(); // This api ref is used for exporting via a custom button in the Dialog Header

  return (
    <CanopyProvider>
      <DialogBase
        fullWidth
        open={open}
        onClose={onClose}
        header={
          <DialogHeader title={title}>
            <IconButton
              onClick={() =>
                dataGridApiRef.current?.exportDataAsCsv({
                  fileName: exportFileName,
                  utf8WithBom: true,
                })
              }
            >
              <DownloadIcon
                fontSize='small'
                sx={(theme) => ({ color: theme.vars.palette.text.secondary })}
              />
            </IconButton>
          </DialogHeader>
        }
      >
        <GridComponent dataGridApiRef={dataGridApiRef} />
      </DialogBase>
    </CanopyProvider>
  );
};
